// a lightweight version of lodash/transform
export function transform(obj, f) {
  // a place to mutate
  var internal = {};
  // basically we have to reduce the keys down to an object and pass the k/v pairs to each f
  Object.keys(obj).forEach(function (key) {
    return f(internal, obj[key], key);
  });
  // return the object we've been building up
  return internal;
}